import React from "react";
import { connect } from "react-redux";
import { setEditData, setModalTemplate, setModalType, setShowEditItemGroupModal } from '../../redux/modal/modal.actions';
import { createStructuredSelector } from 'reselect';
import { selectEditUUID, selectModalFormTemplate, selectShowEditItemGroupModal } from "../../redux/modal/modal.reselect";
import { useEffect } from "react";

import EDIT_ITEM_GROUP_FORM_TEMPLATE from './edit-item-group.template';

import ModalContainer from "../modal/modal.container";
import useFetchEdit from "../../effects/use-fetch-edit.effect";
import { authTokenSelector } from "../../redux/user/user.reselect";

const EditItemGroup = ({
    showEditItemGroup,
    setModalTemplate,
    setModalType,
    formTemplate,
    editUUID,
    authToken,
    setShowEditItemGroupModal,
    isFetching,
    setEditData
}) => {
    useEffect(() => {
        setModalType("EDIT_ITEM_GROUP")
        setModalTemplate(EDIT_ITEM_GROUP_FORM_TEMPLATE);
    }, []);
    const endpoint = '/itemgroups';
    const endpointUrl = `${endpoint}/${editUUID}`;
    const authTokenFromState = authToken;

    const { data, error } = useFetchEdit(endpointUrl, authTokenFromState, showEditItemGroup);

    useEffect(() => {
        setEditData(data)
    })
    
    return (
        <div className="edit-item-group">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showEditItemGroup}
                        setShowModal={setShowEditItemGroupModal}
                        endpointUrl={endpointUrl}
                        size={"SMALL"}
                    />
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showEditItemGroup: selectShowEditItemGroupModal,
    formTemplate: selectModalFormTemplate,
    editUUID: selectEditUUID,
    authToken: authTokenSelector,
})

const mapDispatchToProps = (disptach) => ({
    setShowEditItemGroupModal: () =>
        disptach(setShowEditItemGroupModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType)),
    setEditData: (editData) =>
        disptach(setEditData(editData))
})


export default connect(mapStateToProps, mapDispatchToProps)(EditItemGroup);